import React, { useState } from 'react';

import { ToolbarMenu } from './PositionsToolbar';

import Button from 'CommonComponents/Button';

import PlusIcon from 'Assets/icons/plus.svg';

// Paid, Secondee, Volunteer, Consultant; labels come translated from the page.
const CREATE_TYPES = ['P', 'S', 'V', 'C'];

const SELECT_CLASS = 'select select-input !tw-bg-white !tw-border tw-w-full';

/** Department and cost centre options, each cost centre under its department. */
const parentOptions = (departments) =>
    departments.flatMap((department) => [
        { value: `Department:${department.id}`, label: department.name },
        ...(department.costcenters ?? []).map((costcenter) => ({
            value: `Costcenter:${costcenter.id}`,
            label: `${department.name} / ${costcenter.name}`,
        })),
    ]);

/** Picks where a new position goes and its type, then opens the position form for them. */
export default function AddPositionMenu({ createUrl, departments, positionTypes }) {
    const [parent, setParent] = useState('');
    const [type, setType] = useState(CREATE_TYPES[0]);

    const [modelType, modelId] = parent.split(':');
    const href = parent ? `${createUrl}?${new URLSearchParams({ model_id: modelId, model_type: modelType, type })}` : undefined;

    return (
        <ToolbarMenu label={$t('Add Position')} variant="primary" icon={<PlusIcon className="tw-w-3 tw-h-3" aria-hidden="true" />} panelRole="dialog">
            <div className="tw-w-72 tw-space-y-3 tw-p-2">
                <label className="tw-flex tw-flex-col tw-gap-y-1 tw-mb-0">
                    <span className="tw-text-xs tw-font-medium tw-text-charcoal-75">{$t('Department / Cost Centre')}</span>
                    <select className={SELECT_CLASS} value={parent} onChange={(e) => setParent(e.target.value)}>
                        <option value="" disabled>
                            {$t('Choose a department or cost centre')}
                        </option>
                        {parentOptions(departments).map((option) => (
                            <option value={option.value} key={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </label>
                <label className="tw-flex tw-flex-col tw-gap-y-1 tw-mb-0">
                    <span className="tw-text-xs tw-font-medium tw-text-charcoal-75">{$t('Type')}</span>
                    <select className={SELECT_CLASS} value={type} onChange={(e) => setType(e.target.value)}>
                        {CREATE_TYPES.map((value) => (
                            <option value={value} key={value}>
                                {positionTypes[value]}
                            </option>
                        ))}
                    </select>
                </label>
                <div className="tw-flex tw-justify-end">
                    {href ? (
                        <Button as="a" variant="primary" small href={href} data-action="navigate" className="edit-locked-budget-entity">
                            {$t('Continue')}
                        </Button>
                    ) : (
                        <Button variant="primary" small disabled>
                            {$t('Continue')}
                        </Button>
                    )}
                </div>
            </div>
        </ToolbarMenu>
    );
}
